import { render, staticRenderFns, recyclableRender, components } from "./orders.vue?vue&type=template&id=8a71bbb4&scoped=true&"
var renderjs
import script from "./orders.vue?vue&type=script&lang=js&"
export * from "./orders.vue?vue&type=script&lang=js&"
import style0 from "./orders.vue?vue&type=style&index=0&id=8a71bbb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a71bbb4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/orders/orders.vue"
export default component.exports